import { ParsleyMark, ParsleyWordmark } from '@parsleyai/ui'
import type React from 'react'

const LoadingScreen: React.FC = () => (
  <div className="relative min-h-screen flex flex-col items-center justify-center bg-background bg-dot-grid">
    <div className="relative z-10 flex flex-col items-center gap-5">
      <div className="p-3 rounded-2xl animate-pulse bg-brand-green/10">
        <ParsleyMark filled className="size-11 text-brand-green" />
      </div>
      <ParsleyWordmark tone="green" size="lg" />
    </div>
  </div>
)

export default LoadingScreen
